/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxMinDto } from '../../models/backend-tax-min-dto';

export interface ProjectTaxesTaxMinRetrieve$Params {
  id: number;
}

export function projectTaxesTaxMinRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxMinRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxMinDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxMinRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxMinDto>;
    }),
  );
}

projectTaxesTaxMinRetrieve.PATH = '/api/project_taxes/tax_min/{id}/';
